import ApiService from '../../index'

export const providers = async (query) => {
  const URI = `/api/provider?${new URLSearchParams(query)}`

  const response = await ApiService.get(URI)

  return response.data
}

export const toggleStatus = async (id) => {
  const URI = `/api/provider/disable/${id}`

  const response = await ApiService.post(URI, {})

  return response
}

export const deleteProvider = async (id) => {
  const URI = `/api/provider/${id}`

  const response = await ApiService.delete(URI)

  return response
}

export const addProvider = async (user) => {
  const URI = `/api/provider`

  const response = await ApiService.post(URI, user)

  return response.data
}

export const updateProvider = async (user) => {
  const URI = `/api/provider/${user.id}`

  const response = await ApiService.patch(URI, user)

  return response.data
}
